const STATE = {
  idle: 'idle',
  running: 'running',
  paused: 'paused',
  resumed: 'resumed',
}

export class IntervalTimer {
  state: string = STATE.idle
  pausedTime: number = 0
  remainingTime: number = 0
  lastFireTime: number
  lastPauseTime: number
  callback: Function
  interval: number
  timerId: ReturnType<typeof setInterval>
  resumeId: ReturnType<typeof setTimeout>

  constructor(callback, interval) {
    this.interval = interval
    this.callback = callback
  }

  proxyCallback() {
    this.lastFireTime = new Date().valueOf()

    this.callback()
  }

  start() {
    this.timerId = setInterval(() => this.proxyCallback(), this.interval)

    this.lastFireTime = new Date().valueOf()

    this.state = STATE.running
  }

  pause() {
    if (this.state !== STATE.running && this.state !== STATE.resumed) {
      return
    }

    this.remainingTime =
      this.interval -
      (new Date().valueOf() - this.lastFireTime) +
      this.pausedTime
    this.lastPauseTime = new Date().valueOf()

    clearInterval(this.timerId)
    clearTimeout(this.resumeId)

    this.state = STATE.paused
  }

  resume() {
    if (this.state !== STATE.paused) {
      return
    }

    this.pausedTime += new Date().valueOf() - this.lastPauseTime

    this.state = STATE.resumed

    this.resumeId = setTimeout(() => this.timeoutCallback(), this.remainingTime)
  }

  timeoutCallback() {
    if (this.state !== STATE.resumed) {
      return
    }

    this.pausedTime = 0

    this.proxyCallback()
    this.start()
  }

  stop() {
    if (this.state === STATE.idle) {
      return
    }

    clearInterval(this.timerId)
    clearTimeout(this.resumeId)

    this.state = STATE.idle
  }

  setInterval(newInterval) {
    if (this.state === STATE.running) {
      this.pause()

      this.interval = newInterval

      this.resume()
    } else {
      this.interval = newInterval
    }
  }
}
